const normalizeRedirect = (url?: string) => {
	if (!url) return undefined;
	return url.replace(/\/+$/, '');
};

const getDevRedirect = () => {
	if (typeof window === 'undefined') return undefined;
	if (process.env.NODE_ENV === 'production') return undefined;

	const base = (process.env.REACT_APP_PUBLIC_URL || '').replace(/\/+$/, '');
	return normalizeRedirect(`${window.location.origin}${base}`);
};

const devRedirect = getDevRedirect();

const awsconfig = {
	aws_project_region: process.env.REACT_APP_REGION,
	aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL_ID,
	aws_cognito_region: process.env.REACT_APP_REGION,
	aws_user_pools_id: process.env.REACT_APP_POOL_ID,
	aws_user_pools_web_client_id: process.env.REACT_APP_POOL_WEB_CLIENT_ID,
	oauth: {
		domain: process.env.REACT_APP_OAUTH_DOMAIN,
		redirectSignIn:
			devRedirect || normalizeRedirect(process.env.REACT_APP_REDIRECT_SIGNIN),
		redirectSignOut:
			devRedirect || normalizeRedirect(process.env.REACT_APP_REDIRECT_SIGNOUT),
		responseType: 'code',
		scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
	},
};

export default awsconfig;
